// src/hooks/useS3File.js
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-extraneous-dependencies */
import { GetObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { useEffect, useState } from "react";

const REGION = process.env.REACT_APP_AWS_REGION || "ap-south-1"; // Replace with your region
const s3Client = new S3Client({
  region: REGION,
  credentials: {
    accessKeyId:
      process.env.REACT_APP_AWS_ACCESS_KEY_ID || "AKIAYDGMXQ5OKQDTKTBB", // Replace with your access key
    secretAccessKey:
      process.env.REACT_APP_AWS_ACCESS_KEY ||
      "lVcx7OCBfxNJ7okgxwA5bYSEEZlWennVXP1Kz8yr", // Replace with your secret access key
  },
});

const useS3File = (file) => {
  const [fileContent, setFileContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let objectUrl;

    const fetchFile = async () => {
      try {
        const command = new GetObjectCommand({
          Bucket: process.env.REACT_APP_AWS_BUCKET || "shohoz-amusement-park",
          Key: `public/${file.split("public/")[1]}`,
        });
        const response = await s3Client.send(command);

        // Convert the Body stream to a Blob
        const bodyContents = await response.Body;
        const reader = bodyContents.getReader();
        const stream = new ReadableStream({
          start(controller) {
            return pump();
            function pump() {
              return reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                  return;
                }
                controller.enqueue(value);
                return pump();
              });
            }
          },
        });
        const blob = await new Response(stream).blob();

        // Create an object URL for the Blob
        objectUrl = URL.createObjectURL(blob);
        setFileContent(objectUrl);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFile();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [file]);

  return { fileContent, loading, error };
};

export default useS3File;
